<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records recommended-questionnaire">
            <div class="row">
                <div class="col-12 mb-4">
                    <div class="card border-0">
                        <div class="card-body p-0 bg-white border-radius-5 p-4 mb-4">
                            <div class="row no-gutters justify-content-center">
                                <div class="col-lg-10">
                                    <div class="Adverse">
                                        <div class="d-flex justify-content-between align-items-center pb-2">
                                            <h2>Adverse Childhood Experience (ACE)</h2>
                                            <p>Question 1 of 10</p>
                                        </div>
                                        <figure class="mb-0"><img src="../../../../static/website/images/progress-bar.png" alt="" /></figure>
                                    </div>
                                    <div class="question mt-5 text-left">
                                        <h3>How would you rate your energy level?</h3>
                                        <form class="radio-box question-radio">
                                            <div class="form-group m-0">
                                                <input type="checkbox" id="terrible" />
                                                <label class="mb-0" for="terrible">Terrible</label>
                                            </div>
                                            <div class="form-group m-0">
                                                <input type="checkbox" id="Poor" />
                                                <label class="mb-0" for="Poor">Poor</label>
                                            </div>
                                            <div class="form-group m-0">
                                                <input type="checkbox" id="Average" />
                                                <label class="mb-0" for="Average">Average</label>
                                            </div>
                                            <div class="form-group m-0">
                                                <input type="checkbox" id="Good" />
                                                <label class="mb-0" for="Good">Good</label>
                                            </div>
                                            <div class="form-group m-0">
                                                <input type="checkbox" id="Excellent" />
                                                <label class="mb-0" for="Excellent">Excellent</label>
                                            </div>
                                        </form>
                                        <div class="button-area d-flex justify-content-between align-items-center mt-5">
                                            <a href="" class="btn btn-prev"><i class="icon icon-chevron-down"></i>Previous</a>
                                            <router-link to="/submit-question" class="btn btn-blue save">Save & Continue</router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "intake-questionaries-question",
        data() {
            return {};
        },
        created(){
           this.pageName('Intake Questionnaire')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/questionaries/intake-questionaries-question.vue